import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Hero from "../components/Tisva/Hero";
import IndustriesContent from "../components/Tisva/IndustriesContent";
import PageTitle from "../components/Tisva/PageTitle";

import "../assets/Webdevelopment.css";

const Tisva = () => {
  return (
    <div className="App">
      <PageTitle />
      <Hero />
      <IndustriesContent />
    </div>
  );
};

export default Tisva;
